// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { EndpointSourceSchema } from '../inputTypeSchemas/EndpointSourceSchema'

/////////////////////////////////////////
// WEB PAGE SCHEMA
/////////////////////////////////////////

export const WebPageSchema = z.object({
  sources: EndpointSourceSchema.array(),
  id: z.string(),
  tenantId: z.string().nullable(),
  applicationId: z.string(),
  credentialsId: z.string().nullable(),
  hash: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  description: z.string().nullable(),
  url: z.string(),
  regex: z.string().nullable(),
  enrichedDataAt: z.coerce.date().nullable(),
  linksInternal: z.string().array(),
  linksExternal: z.string().array(),
})

export type WebPage = z.infer<typeof WebPageSchema>

export default WebPageSchema;
